export const LL_SITE_DIRECORY_PARTNER_ID = '1000';
export const LL_SSDCAT = '243';
